import React, {useEffect, useRef} from 'react';
import {Checkbox, Divider, Form, Input, Radio} from 'antd';
import NewsThumbEditor from '@/page/component/NewsFormModal/NewsForm/NewsThumbEditor';
import {useExtraNewsStore} from './context';
import ExtraNewsUpload from './ExtraNewsUpload';

function ExtraNewsForm() {
    const formRef = useRef();
    const [store, dispatch] = useExtraNewsStore();
    const currentNews = store.newsById[store.currentTmpId];
    console.log('formValue', currentNews);

    useEffect(() => {
        formRef.current && formRef.current.setFieldsValue(currentNews);
    }, [currentNews]);

    const layout = {
        labelCol: {span: 3}, // wrapperCol: {span: 20},
    };
    const tailLayout = {
        wrapperCol: {offset: 3},
    };

    function dispatchCurrentNewsForm() {
        dispatch([
            'updateCurrentNewsForm',
            {
                currentTmpId: store.currentTmpId,
                news: formRef.current.getFieldsValue(),
            },
        ]);
    }

    function onValuesChange(changedValues) {
        console.log('onValuesChange', changedValues);
        let extra = {};
        // 禁止拷贝
        if (changedValues.hasOwnProperty('newsContentForbidCopy')) {
            const forbidCopy = changedValues.newsContentForbidCopy;
            if (forbidCopy) {
                extra = {
                    newsAccessType: 1,
                };
            } else {
                extra = {
                    newsContentMask: false,
                };
            }
            formRef.current.setFieldsValue(extra);
        }

        // 加水印
        if (changedValues.hasOwnProperty('newsContentMask')) {
            const mask = changedValues.newsContentMask;
            if (mask) {
                extra = {
                    newsContentForbidCopy: true, // newsShowReadNum: false,
                    // newsShowPraiseNum: false,
                    newsAccessType: 1,
                };
                formRef.current.setFieldsValue(extra);
            }
        }

        dispatchCurrentNewsForm();
    }

    function onThumbChange(thumbAttachId, thumbAttachExt) {
        console.log(thumbAttachId, thumbAttachExt);

        formRef.current.setFields([
            {
                name: 'thumbAttachId',
                value: thumbAttachId,
            },
            {
                name: 'thumbAttachExt',
                value: thumbAttachExt,
            },
        ]);
        dispatchCurrentNewsForm();
    }

    function onFinish(values) {
        console.log('Received values of form: ', values);
    }

    return (
        <Form
            ref={formRef}
            {...layout}
            labelAlign="left"
            onFinish={onFinish}
            onValuesChange={onValuesChange}
            layout="horizontal"
        >
            <Form.Item hidden name="id">
                <Input />
            </Form.Item>

            <Form.Item
                name="title"
                label="标题"
                rules={[
                    {
                        required: true,
                    },
                ]}
            >
                <Input placeholder="在此输入标题" maxLength={30} size="large" />
            </Form.Item>

            <Form.Item name="description" label="摘要">
                <Input.TextArea placeholder="摘要" maxLength={50} rows={2} />
            </Form.Item>

            <Divider />

            <Form.Item hidden name="thumbAttachId">
                <Input />
            </Form.Item>

            <Form.Item hidden name="thumbAttachExt">
                <Input />
            </Form.Item>

            <NewsThumbEditor news={currentNews} onThumbChange={onThumbChange} />

            <Divider />

            <ExtraNewsUpload />

            <Divider />

            <Form.Item name="newsCommentType" label="留言控制">
                <Radio.Group>
                    <Radio value={0}>开启留言，仅企业微信成员可留言</Radio>
                    <Radio value={1}>关闭留言</Radio>
                </Radio.Group>
            </Form.Item>
            <Form.Item name="newsAccessType" label="安全控制">
                <Radio.Group disabled={currentNews?.newsContentForbidCopy}>
                    <Radio value={1}>仅企业微信成员可访问</Radio>
                    <Radio value={0}>无限制，所有人可访问</Radio>
                </Radio.Group>
            </Form.Item>
            <Form.Item
                {...tailLayout}
                name="newsContentForbidCopy"
                valuePropName="checked"
                extra="如图文存在可点击内容，请不要选择此项"
            >
                <Checkbox>正文禁止复制</Checkbox>
            </Form.Item>
            <Form.Item wrapperCol={{offset: 4}} name="newsContentMask" valuePropName="checked">
                <Checkbox>正文加水印</Checkbox>
            </Form.Item>
            <Form.Item {...tailLayout} name="newsShowReadNum" valuePropName="checked">
                <Checkbox>展示阅读数</Checkbox>
            </Form.Item>
            <Form.Item {...tailLayout} name="newsShowPraiseNum" valuePropName="checked">
                <Checkbox>展示点赞数</Checkbox>
            </Form.Item>
        </Form>
    );
}

export default ExtraNewsForm;
